import styles from './NotificationSettings.module.css'
import { useDynamicMainToolbar } from 'shared/hooks/useMainToolbar'
import { ApplicationMainToolbarContent } from 'shared/widgets/ApplicationMainToolbarContent'
import { useNavigate } from 'react-router-dom'
import { NotificationsSettingsFormUpdate } from '../NotificationsSettingsFormUpdate'
    
export const NotificationSettings = (): JSX.Element => {
    const navigate = useNavigate()

    const handleBack = () => {
        navigate(-1)
    }
    
    const mainToolbarContent = (
        <ApplicationMainToolbarContent
            title={`Notifications Settings`}
            back={{
                callback:handleBack
            }}
        />
    )
    
    useDynamicMainToolbar(mainToolbarContent, [])
        return (
            <div >
                <div className={styles.NotificationSettings__FormUpdateContainer}>
                    <NotificationsSettingsFormUpdate />
                </div>        
            </div>
        )
    }
